var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.notification
    ? _c("div", { staticClass: "subcontainer" }, [
        _c(
          "button",
          {
            staticClass: "collapsible active",
            attrs: { id: "notificationBanner", type: "button" },
            on: { click: _vm.toggleNotification },
          },
          [_vm._v("\n    " + _vm._s(_vm.header) + "\n  ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.sanitizeHtml(_vm.notification)) },
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }